// T2T-05-C3-UI — Scrollable message list. Renders system / internal / vendor
// variants. Empty state when no messages yet.

import React from "react";
import PropTypes from "prop-types";
import MessageRow from "./MessageRow";

export default function MessageList({
  messages, currentUserId, onLoadOlder, hasMore, loadingOlder,
  onEdit, onDelete, onOpenAttachment, onRefresh,
}) {
  if (!messages || messages.length === 0) {
    return (
      <div style={{
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
        padding: "40px 16px", textAlign: "center",
      }}>
        <i className="bi bi-chat-dots" style={{ fontSize: 36, color: "var(--t2t-border)", marginBottom: 10 }} />
        <p style={{ fontWeight: 600, fontSize: 13, color: "var(--t2t-text-secondary)", marginBottom: 4 }}>
          No messages yet
        </p>
        <p style={{ fontSize: 12, color: "var(--t2t-text-muted)", maxWidth: 240, margin: 0 }}>
          Start the conversation. Use @ to mention someone in the workflow.
        </p>
      </div>
    );
  }

  return (
    <div>
      {hasMore && (
        <div style={{ textAlign: "center", marginBottom: 8 }}>
          <button
            type="button"
            className="t2t-btn t2t-btn-ghost t2t-btn-sm"
            onClick={onLoadOlder}
            disabled={loadingOlder}
            style={{ fontSize: 11 }}
          >
            {loadingOlder ? "Loading…" : "Load older messages"}
          </button>
        </div>
      )}
      {messages.map((m) => (
        <MessageRow
          key={m.message_id}
          message={m}
          isMine={Number(m.sender_id) === Number(currentUserId)}
          onEdit={onEdit}
          onDelete={onDelete}
          onOpenAttachment={onOpenAttachment}
        />
      ))}
      <div style={{ textAlign: "center", marginTop: 8 }}>
        <button
          type="button"
          className="t2t-btn t2t-btn-ghost t2t-btn-sm"
          onClick={onRefresh}
          style={{ fontSize: 11 }}
          title="Reload thread (live updates arrive in C4)"
        >
          <i className="bi bi-arrow-clockwise" /> Refresh
        </button>
      </div>
    </div>
  );
}

MessageList.propTypes = {
  messages:         PropTypes.array.isRequired,
  currentUserId:    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onLoadOlder:      PropTypes.func.isRequired,
  hasMore:          PropTypes.bool,
  loadingOlder:     PropTypes.bool,
  onEdit:           PropTypes.func.isRequired,
  onDelete:         PropTypes.func.isRequired,
  onOpenAttachment: PropTypes.func.isRequired,
  onRefresh:        PropTypes.func.isRequired,
};
